import React, { Component } from 'react';
import { Divider, Dimmer, Loader, Icon } from 'semantic-ui-react'
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import { alertsURL, alertDismissURL } from "../../shared/urls/clientapi";
import { callService, GET, PUT } from "../../shared/serviceInvoker";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

export default class RemindersList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showLoader: true
        }
    }

    handleDismiss = (event) => {
        let alert_id = event.target.id;
        let url = alertDismissURL.replace('{alert_id}', alert_id);

        callService(
            PUT,
            url,
            null,
            response => {

                let note = "Alert ID: " + alert_id + " has been dismissed.";
                ReactGA.event({
                    category: 'Reminders',
                    action: note,
                });
                trackEvent('Reminders', note);
                this.componentDidMount();
            },
            error => {
                // this.setState({ redirectToReferrer: true, error: true });
            }
        )

    };

    componentDidMount() {

        let url = alertsURL.replace('{contact_id}', sessionStorage.contact_id);
        callService(
            GET,
            url,
            null,
            response => {
                var result = response.data.data;
                let alert = [];

                for (let i = 0; i < result.length; i++) {
                    let add_alert = {
                        'id': result[i].id,
                        'text': result[i].text,
                    }
                    alert.push(add_alert)
                }

                if (alert.length < 1) {
                    let add_alert = {
                        'id': 0,
                        'text': 'Nothing right now, but keep an eye on this space for important information',
                    }
                    alert.push(add_alert)
                }

                this.setState({
                    data: alert,
                    showLoader: false
                });
            },
            error => {
                var result = [];
                this.setState({
                    data: result,
                    showLoader: false
                });
            }
        );
    }

    render() {

        const { showLoader } = this.state;
        const PageLoader = () => (
            <Dimmer active={showLoader} inverted>
                <Loader size='medium'>Loading Reminders ...</Loader>
            </Dimmer>
        )

        const responsive = {
            0: {
                items: 1
            }
        };

        const alert_list = this.state.data.map((row, index) => {
            let reminder;
            if (row.id === 0) {
                reminder = <div className='carousel-reminders' >{row.text}</div>
            } else {
                reminder = <div className='carousel-reminders' >{row.text} &nbsp;&nbsp;
                <Icon id={row.id} link title='Click to Dismiss' name='window close outline' onClick={this.handleDismiss} />
                </div>
            }
            return reminder;
        });

        return (
            <div>
                <div><b>REMINDERS</b></div>
                <div>&nbsp;</div>
                <Divider fitted />
                <br />
                <PageLoader />
                <AliceCarousel
                    responsive={responsive}
                    items={alert_list}
                    fadeOutAnimation={true}
                    mouseDragEnabled={true}
                    buttonsDisabled={true}
                >

                </AliceCarousel>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RemindersList/index.js